import { Entitlement } from "../../model";
import apiService from "../ApiService";

const passReactivate = (entitlement: Entitlement) => {
  return apiService.put<void>({
    path: `public/account/game_passes/${entitlement.items?.[0]}/reactivate`,
    crm: true,
  });
};
export { passReactivate };
